/** @param {unknown} value */
export function firstQueryParam(value) {
  if (Array.isArray(value)) return value[0]
  return value
}
